var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarningTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.538,
    viewBox: "0 0 20 16.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5924",
    "data-name": "Group 5924",
    transform: "translate(0 -44.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896",
    transform: "translate(0 44.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M14.615,49.693H20v-2.5a2.888,2.888,0,0,0-2.885-2.885H2.885A2.888,2.888,0,0,0,0,47.193V57.962a2.888,2.888,0,0,0,2.885,2.885H17.115A2.888,2.888,0,0,0,20,57.962v-2.5H14.615a2.885,2.885,0,1,1,0-5.769Z",
    transform: "translate(0 -44.308)",
    fill: "#f3f6fd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898",
    transform: "translate(12.885 50.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    d: "M331.577,211.692a1.731,1.731,0,0,0,0,3.462h5.385v-3.462h-5.385Zm.769,2.308h-.769a.577.577,0,0,1,0-1.154h.769a.577.577,0,1,1,0,1.154Z",
    transform: "translate(-329.846 -211.692)",
    fill: "#f3f6fd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningTab);
export default __webpack_public_path__ + "static/media/earningTab.47ef2b38338a21794ce72dc7d8072bab.svg";
export { ForwardRef as ReactComponent };